import {environment} from '../../../environments/environment';

export const APP_CONFIG: any = {
  BASE_API_LINK: {
    BASE: environment.url,
    USER: environment.url + '/users',
    USER_SETTING: environment.url + '/user-setting',
    ROUND_PROFIT: environment.url + '/round-profit',
    DASHBOARD: environment.url + '/dashboard',
    ENTRY_PROFIT: environment.url + '/entry-profit',
    PRICE_SETTING: environment.url + '/price',
    PLATFORM_SETTING: environment.url + '/platform-setting',
    BONUS_SETTING: environment.url + '/bonus',
    DEALING: environment.url + '/dealing',
    AFFILIATE: environment.url + '/affiliate',
    CMS: environment.url + '/cms',
    GROUP: environment.url + '/group',
    WALLET: environment.url + '/wallet',
    REWARD: environment.url + '/reward',
    BONUS: environment.url + '/bonus',
    IB_RANKING: environment.url + '/ib-ranking',
    IB: environment.url + '/ib',
    IB_REWARD: environment.url + '/ib-reward',
    TRADE_PERFORMANCE: environment.url + '/trade-performance',
    INVESTMENT: environment.url + '/investment',
    FOUNDER: environment.url + '/founder',
    EMAIL_MARKETING:environment.url + '/email-marketing',
  },
};
